import React from "react";
import Banner from "../../components/templates/home/Privacy/Banner";
import Content from "../../components/templates/home/Privacy/Content";

const Rates = () => {
  return (
    <div>
      <Banner />
      <Content />
    </div>
  );
};

export default Rates;
